// extracted by mini-css-extract-plugin
module.exports = {"root":"Chip_root__1gM4w","selected":"Chip_selected__XsKRG"};